// extracted by mini-css-extract-plugin
export var container = "_6z-0";
export var infoButton = "_6z-1";
export var label = "_6z-3";
export var labelExpanded = "_6z-4";
export var price = "_6z-5";
export var priceExpanded = "_6z-6";
export var title = "_6z-2";